import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {Col, Row} from "antd";
import {Button, Loading} from "~/components";
import {
	InputField,
	InputPriceField,
	SelectField,
	SelectUserAll,
	SelectContractAll,
	DateField
} from "~/components/Forms";

const AD_STATUS_OPTIONS = [
	{value: '', label: 'Chưa đánh giá'},
	{value: 'excellent', label: 'Rất tốt'},
	{value: 'good', label: 'Tốt'},
	{value: 'average', label: 'Trung bình'},
	{value: 'poor', label: 'Kém'},
];

function MarketingProjectFormAddEdit({item, onHandleSubmit}) {

	const isEdit = Boolean(item?.id);

	const assignOptions = (isEdit && item.assign?.id) ? [{label: `${item.assign.firstname} ${item.assign.lastname}`, value: item.assign.id}] : [];

	const initialValues = {
		contractId: undefined,
		assignId: '',
		websiteName: '',
		startDate: new Date(),
		endDate: new Date(),
		budgetDailyNeeded: 0,
		vat: 0,
		reportLink: '',
		channelLink: '',
		adStatus: '',
		note: '',
	}

	const validationSchema = Yup.object().shape({
		contractId: isEdit ? Yup.mixed() : Yup.number().typeError('Bạn chưa chọn hợp đồng').required('Bạn chưa chọn hợp đồng'),
		endDate: Yup.string().required('Bạn chưa chọn thời gian kết thúc'),
	});

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		if (item?.id) {
			initialValues.assignId = item.assignId || '';
			initialValues.websiteName = item.websiteName || '';
			initialValues.startDate = item.startDate ? item.startDate * 1000 : new Date();
			initialValues.endDate = item.endDate ? item.endDate * 1000 : new Date();
			initialValues.budgetDailyNeeded = item.budgetDailyNeeded || 0;
			initialValues.vat = item.vat || 0;
			initialValues.reportLink = item.reportLink || '';
			initialValues.channelLink = item.channelLink || '';
			initialValues.adStatus = item.adStatus?.key || item.adStatus || '';
			initialValues.note = item.note || '';
		}
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) => {
		await onHandleSubmit(data, isEdit);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			{!isEdit && (
				<>
					<p className="heading">Hợp đồng marketing</p>
					<Controller control={control} name="contractId" render={({field}) => (
						<SelectContractAll label="Hợp đồng (đã thu doanh thu)" channel="marketing" options={[]} errors={errors} {...field} />
					)}/>
				</>
			)}
			<p className="heading">Thông tin dự án</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="assignId" render={({field}) => (
						<SelectUserAll label="Nhân viên kỹ thuật" department="marketingTechnical" options={assignOptions} errors={errors} {...field} />
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="websiteName" render={({field}) => (
						<InputField label="Tên website" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="startDate" render={({field}) => (
						<DateField label="Bắt đầu" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="endDate" render={({field}) => (
						<DateField label="Kết thúc" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<p className="heading">Ngân sách</p>
			<p style={{fontSize: 12, color: '#888', marginTop: -6}}>Ngân sách thực thu & sau thuế tự cập nhật theo doanh thu ngân sách đã thu của hợp đồng (có thể nhiều đợt).</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="vat" render={({field}) => (
						<InputField label="% VAT (tính sau thuế)" type="number" suffix="%" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="budgetDailyNeeded" render={({field}) => (
						<InputPriceField label="Cần chi / ngày" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<p className="heading">Liên kết & ghi chú</p>
			<Controller control={control} name="reportLink" render={({field}) => (
				<InputField label="Liên kết báo cáo (google sheet)" errors={errors} {...field}/>
			)}/>
			<Controller control={control} name="channelLink" render={({field}) => (
				<InputField label="Liên kết fanpage / tiktok" errors={errors} {...field}/>
			)}/>
			{isEdit && (
				<Controller control={control} name="adStatus" render={({field}) => (
					<SelectField label="Trạng thái chạy quảng cáo" options={AD_STATUS_OPTIONS} errors={errors} {...field}/>
				)}/>
			)}
			<Controller control={control} name="note" render={({field}) => (
				<InputField label="Ghi chú" errors={errors} {...field}/>
			)}/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">{isEdit ? 'Cập nhật' : 'Tạo'} dự án</Button>
			</div>
		</form>
	)
}

export default MarketingProjectFormAddEdit;
